export const numericWithOptionalDecimalRegex = /^(\d*)([.,])?(\d*)$/;
export const capRegex = /^[0-9]{5}$/;
export const emailRegex = /([a-zA-Z0-9_\-\.]+)@((([a-zA-Z0-9\-]{1,}\.)+))([a-zA-Z]{2,4})(\]?)/;
export const pecRegex = /([a-zA-Z0-9_\-\.]+)@((([a-zA-Z0-9\-]{1,}\.)+))([a-zA-Z]{2,4})(\]?)|(non presente)/;
export const posizAlboEntiRegex = /^[A-Z][0-9]{6}$/;
export const onlyNumberRegex = /^[0-9]+$/;
export const yearsRangeRegex = /^(\d{4})\s*\/\s*(\d{4})$/;
export const isoDateYYYYMMDDRegex = /^(\d{4})-(\d{2})-(\d{2})$/;
export const onlyConsonantRegex = /[^BCDFGHJKLMNPQRSTVWXYZ]/gi;
export const onlyVowelsRegex = /[^AEIOU]/gi;
export const legacySlashDateRegex = /^(\d{4})\/(\d{2})\/(\d{2})$/;
